import { render } from "./InputUpload.vue?vue&type=template&id=088e1505"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"

import "./InputUpload.vue?vue&type=style&index=0&id=088e1505&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__